export enum ModalType {
  SCOREBOARD = 'SCOREBOARD',
  NEW_GAME = 'NEW_GAME',
  FAIL = 'FAIL',
  DECISION = 'DECISION',
  GIVE_UP = 'GIVE_UP',
  CONGRATS = 'CONGRATS',
  ARE_YOU_SURE = 'ARE_YOU_SURE',
  MONTHLY = 'MONTHLY',
  PAYMENT_SUCCESS = 'PAYMENT_SUCCESS',
  DRAWER_HOW_TO_PLAY = 'DRAWER_HOW_TO_PLAY',
  DRAWER_FAQ = 'DRAWER_FAQ',
  DRAWER_CONTACT_US = 'DRAWER_CONTACT_US',
}
